import React from 'react';

interface Props {
  classname: string;
}

export class ContextualButtonSelectedIcon extends React.PureComponent<Props> {
  public render(): React.ReactNode {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <path
          className={this.props.classname}
          d="M6 10.586l7.293-7.293 1.414 1.414L6 13.414 1.293 8.707l1.414-1.414z"
        />
      </svg>
    );
  }
}
